// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderTituloComponent_containerTitulo__ZfH06 {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  align-items: flex-start;
  justify-content: space-between;
  background-color: #ffffff;
  height: auto;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 10px;
  border-radius: 15px;
  width: calc(100% - 30px);
  margin-top: 10px;
  gap: 0px;
}

.HeaderTituloComponent_containerTitulo__ZfH06 h1 {
  font-size: 1rem;
}
.HeaderTituloComponent_ruta__VrXXi a .HeaderTituloComponent_iconoPath__byDdB {
  width: 15px;
  height: 13px;
}
.HeaderTituloComponent_ruta__VrXXi a .HeaderTituloComponent_iconoSvg__ZVlli {
  fill: var(--primary-color);
  width: 10px;
}
.HeaderTituloComponent_ruta__VrXXi a:hover .HeaderTituloComponent_iconoSvg__ZVlli {
  fill: var(--primary-color-hover);
}

.HeaderTituloComponent_ruta__VrXXi {
  display: flex;
  flex-direction: row;
  margin-right: 15px;
  align-content: center;
  align-items: center;
  justify-content: center;
  align-self: center;
}
.HeaderTituloComponent_separador__WOtLA {
  width: 20px;
}

.HeaderTituloComponent_separador__WOtLA path {
  stroke: var(--gris-separador);
}
.HeaderTituloComponent_itemPath__ybJGK {
  display: flex;
  align-content: center;
  align-items: center;
}
.HeaderTituloComponent_itemPath__ybJGK a {
  text-decoration: none;
  height: auto;
}

.HeaderTituloComponent_itemPath__ybJGK label {
  font-size: 0.8rem;
  font-weight: bold;
  align-content: center;
  cursor: pointer;
  color: var(--primary-color);
  text-decoration: none;
}

@media (min-width: 640px) {
  /* Ajusta este valor según tus necesidades */

  .HeaderTituloComponent_containerTitulo__ZfH06 {
    flex-direction: row;
    align-items: center;
    padding-left: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/header-titulo/HeaderTituloComponent.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;;EAE5C;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".containerTitulo {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: center;\n  align-items: flex-start;\n  justify-content: space-between;\n  background-color: #ffffff;\n  height: auto;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 5px;\n  padding-bottom: 10px;\n  border-radius: 15px;\n  width: calc(100% - 30px);\n  margin-top: 10px;\n  gap: 0px;\n}\n\n.containerTitulo h1 {\n  font-size: 1rem;\n}\n.ruta a .iconoPath {\n  width: 15px;\n  height: 13px;\n}\n.ruta a .iconoSvg {\n  fill: var(--primary-color);\n  width: 10px;\n}\n.ruta a:hover .iconoSvg {\n  fill: var(--primary-color-hover);\n}\n\n.ruta {\n  display: flex;\n  flex-direction: row;\n  margin-right: 15px;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n}\n.separador {\n  width: 20px;\n}\n\n.separador path {\n  stroke: var(--gris-separador);\n}\n.itemPath {\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.itemPath a {\n  text-decoration: none;\n  height: auto;\n}\n\n.itemPath label {\n  font-size: 0.8rem;\n  font-weight: bold;\n  align-content: center;\n  cursor: pointer;\n  color: var(--primary-color);\n  text-decoration: none;\n}\n\n@media (min-width: 640px) {\n  /* Ajusta este valor según tus necesidades */\n\n  .containerTitulo {\n    flex-direction: row;\n    align-items: center;\n    padding-left: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerTitulo": `HeaderTituloComponent_containerTitulo__ZfH06`,
	"ruta": `HeaderTituloComponent_ruta__VrXXi`,
	"iconoPath": `HeaderTituloComponent_iconoPath__byDdB`,
	"iconoSvg": `HeaderTituloComponent_iconoSvg__ZVlli`,
	"separador": `HeaderTituloComponent_separador__WOtLA`,
	"itemPath": `HeaderTituloComponent_itemPath__ybJGK`
};
export default ___CSS_LOADER_EXPORT___;
